<script setup lang="ts">
import { quantityBus } from '@/event/product/quantityBus'
import { ref } from 'vue'

// const props = defineProps<{ index?: number }>()

const counterProduct = ref(quantityBus.value ? quantityBus.value : 0)

function increment() {
    counterProduct.value++
    quantityBus.value = counterProduct.value
}

function decrement() {
    if (counterProduct.value > 1) {
        counterProduct.value--
        quantityBus.value = counterProduct.value
    }
}
</script>

<template>
    <section class="section-button-select-product-happy">
        <div class="min-w-6 min-h-6">
            <button
                class="button-minus-product-happy"
                @click.stop="decrement()"
                v-if="counterProduct > 1"
            >
                <svg
                    class="svg-minus-happy"
                    viewBox="0 0 15 2"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M1 1H14" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>
        <p class="text-counter-option-value-happy">{{ counterProduct }}</p>

        <button class="button-plus-product-happy" @click.stop="increment()">
            <svg
                class="svg-plus-happy"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1 8.5H16M8.5 1V16"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </button>
    </section>
</template>

<style scoped>
.section-button-select-product-happy {
    @apply flex items-center justify-between gap-2 min-w-28 h-full;
}

.button-minus-product-happy {
    @apply flex items-center border border-button-yellow-happy-light rounded-md p-1;
}

.svg-minus-happy {
    @apply w-5 h-5 stroke-text-dark-happy-light;
}

.text-counter-option-value-happy {
    @apply happy-dark:text-text-dark-happy-light happy-light:text-bg-happy-light text-lg text-center w-6 font-semibold;
}

.button-plus-product-happy {
    @apply flex items-center bg-button-yellow-happy-light p-1 rounded-md;
}
.svg-plus-happy {
    @apply w-5 h-5 stroke-text-dark-happy-light;
}

.button-minus-product-happy:active .svg-minus-happy {
    @apply stroke-text-dark-happy-light;
}
.button-minus-product-happy:active,
.button-plus-product-happy:active {
    @apply bg-hover-yellow-happy border-hover-yellow-happy;
}
@media (hover: hover) {
    .button-plus-product-happy:hover {
        @apply bg-hover-yellow-happy border-hover-yellow-happy;
    }
    .button-minus-product-happy:hover .svg-minus-happy {
        @apply stroke-text-dark-happy-light;
    }
    .button-minus-product-happy:hover {
        @apply bg-hover-yellow-happy border-hover-yellow-happy;
    }
}
</style>
